<div class="row mt-4 mb-2" [formGroup]="form">
  <div class="col-12 col-sm-3 col-md-2">
    Всего: <b>{{count}}</b>
    <app-material-input-checkbox formControlName="is_archive">
      В архиве
    </app-material-input-checkbox>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'">
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      <!-- // -->
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>{{row['create_date']}}</td>
          <td>
            @if (row['resale_realty_id'] && row['allow_update']) {
              <a [routerLink]="['/resale/flat/modify', row['resale_realty_id']]">{{row['resale_realty_caption']}}</a>
            }
            @if (row['resale_realty_id'] && !row['allow_update']) {
              <div>{{row['resale_realty_caption']}}</div>
            }
          </td>
          <td>
            {{row['cause_caption']}}
          </td>
          <td>
            {{row['text']}}
          </td>
          @if (is_crm_part) {
            <td>
              @if (row['author_organisation_id']) {
                <a
                  [routerLink]="['/physical/edit', row['author_organisation_id'], 'common']">{{row['author_organisation']}}
                </a>
              }
            </td>
            <td>
              @if (row['owner_id']) {
                <a
                  [routerLink]="['/physical/edit', row['owner_id'], 'common']">{{row['owner_fio']}}
                </a>
              }
            </td>
            <td>
              @if (row['owner_organisation_id']) {
                <a
                  [routerLink]="['/physical/edit', row['owner_organisation_id'], 'common']">{{row['owner_organisation']}}
                </a>
              }
            </td>
            <td>
              @if (row['author_id']) {
                <a
                  [routerLink]="['/physical/edit', row['author_id'], 'common']">{{row['author_fio']}}
                </a>
              }
            </td>
            <td>
              @if (!row['is_archive']) {
                <div class="button button_icon mt-2" (click)="updateComplaint(row['id'], true)">
                  <i class="fa fa-trash"></i>
                </div>
              }
              @if (row['is_archive']) {
                <div class="button button_icon mt-2" (click)="updateComplaint(row['id'], false)">
                  <i class="fa fa-history"></i>
                </div>
              }
            </td>
          }
        </tr>
      }
    </table>
  </div>
</div>

<div class="alt-pagination">
  <app-paginator
    [queryParams]="filter_columns"
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="current_page"
    [baseUrl]="'/transfer-log'">
  </app-paginator>
</div>
